import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { keyUri, config } from "../../key";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import { Bell } from "lucide-react";
import CarUnavailableIcon from "./unavailable";
import { FormControlLabel, Switch } from "@mui/material";

import Install from "../pwa/install";
import { bookingSelector, fetchAllbooking } from "../../api/bookings";
import { fetchAllroute, routeSelector } from "../../api/route";
import RouteSelectionModal from "./routeselectionmodal";
import { driverSelector, fetchOnedriver } from "../../api/driver";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  getStorage,
  listAll,
} from "firebase/storage";
import storage from "../firebase.config";
import { toast } from "react-toastify";
import { Pencil } from "lucide-react";
import {
  getAllBookings,
  seatBookSelector,
  updateSeatBooks,
} from "../../api/seatbooking";
import "./Animated.css";
import { Box, Button } from "@mui/material";
import {
  createvehicle,
  fetchonevehicle,
  updatevehicle,
  vehicleSelector,
} from "../../api/vehicle";
import {
  createReview,
  fetchReviews,
  reviewSelector,
} from "../../api/driverReview";

import loadout1 from '../../assets/4-Seater Luxury  (2).png';
import loadout2 from '../../assets/5-Seater Luxury .png';
import loadout3 from '../../assets/5-Seater bench Luxury .png';
import loadout4 from '../../assets/5-Seater standard.png';
import loadout5 from '../../assets/6-Seater Luxury .png';
import loadout6 from '../../assets/7-Seater standard.png';
import loadout7 from '../../assets/7-seater standard (1).png'
import loadout8 from '../../assets/8 Seating standard.png'
import loadout9 from '../../assets/8-Seater economy.png';
import loadout10 from '../../assets/10 Seating economy.png'
import loadout11 from '../../assets/Innova Layout.png'



const handileridedetals = (id) => {
  console.log(id);
};

let deferredPrompt;

const Index = () => {
  const { current_vehicle } = useSelector(vehicleSelector);
  const d = new Date(Date.now());
  const date = d.toLocaleDateString("en-GB");
  const weekday = d.toLocaleString("default", { weekday: "long" });
  const user_id = useSelector((state) => state.driver);
  const [loading, setLoading] = useState(true);
  const [installable, setInstallable] = useState(false);
  const [loadoutImages, setLoadoutImages] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const [openAddVehicle, setOpenAddVehicle] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openEditVehicle, setOpenEditVehicle] = useState(false);
  const [vehicle_for_route_change, handlesetvehicleforroutechange] =
    useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  //driver review
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  //const [rideStatus, setRideStatus] = useState("Not Started"); // Add this state to track ride status
  const [review, setReview] = useState([]);
  const [reviewStars, setReviewStars] = useState(0);
  const [reviewComment, setReviewComment] = useState("");

  const [unavailabilityForms, setUnavailabilityForms] = useState({});
  //vehicle typessssssss
  const vehicleTypes = [
    "Sedan",
    "SUV",
    "MPV",
    "Mini-Vans",
    "Hatchbacks",
    "Pickup Trucks",
    "Luxury Buses",
    "Pickup Vans",
  ];
  const seatOptions = [
    { label: "3+1", value: 4 },
    { label: "4+1", value: 5 },
    { label: "5+1", value: 6 },
    { label: "6+1", value: 7 },
    { label: "7+1", value: 8 },
    { label: "8+1", value: 9 },
    { label: "9+1", value: 10 },
    { label: "10+1", value: 11 },
  ];

 const cabfor = [
  { label: "Reserve Cab", value: "Full-Cab" },
  { label: "Shared Cab", value: "Shared-cab" },
  { label: "Both", value: "Both" }
];
  const categoryTypes = ["Luxury", "Standard", "Economy"];


  const loadoutImagess = [
  { url: loadout1, capacity: 4 },
  { url: loadout2, capacity: 6 },
  { url: loadout3, capacity: 6 },
  { url: loadout4, capacity: 5 },
  { url: loadout5, capacity: 6 },
  { url: loadout6, capacity: 7 },
  { url: loadout7, capacity: 7 },
  { url: loadout8, capacity: 8 },
  { url: loadout9, capacity: 9 },
  { url: loadout10, capacity: 11 },
  { url: loadout11, capacity: 6 },
  
];

  const handleOpenAddVehicle = () => setOpenAddVehicle(true);
  const handleCloseAddVehicle = () => setOpenAddVehicle(false);

  const handleChange = (e) => {
    setNewVehicle({ ...newVehicle, [e.target.name]: e.target.value });
  };

  const handileridedetals = (id) => {
    console.log(id);
    navigate(`/ridedetails/${id}`);
  };


  const [open, setOpen] = useState(false);
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [user, setUser] = useState({});
  const [authStatus, setAuthStatus] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);
  const [userid, setUserid] = useState("");
  const { driverAuthenticate, driver } = useSelector((state) => state.driver);
  const [currentDate, setCurrentDate] = useState(new Date());
  // const { all_booking } = useSelector((state) => state.booking);
  console.log(driverAuthenticate);
  const { all_route } = useSelector(routeSelector);
  const { all_booking } = useSelector(bookingSelector);

  const { getAllBooks } = useSelector(seatBookSelector);
  const [showStartButton, setShowStartButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const { current_driver } = useSelector(driverSelector);
  const [rideStatus, setRideStatus] = useState(null);
  const [editmodal, seteditmodal] = useState(false);

  const [fromDate, setFromDate] = useState({});
  const [toDate, setToDate] = useState({});
  const handleseecustomer = (data) => {
    console.log(data);
    setCustomerDetails(data);
    setRideStatus(data?.status);
    setIsModalOpen(true);
  };

  const handleAnimation = () => {
    setIsAnimating(true);

    // Reset animation after it's done (0.8s)
    setTimeout(() => setIsAnimating(false), 800);
  };

  const getAllImageLinksFromFolder = async (folderPath) => {
    const storage = getStorage();
    const listRef = ref(storage, folderPath);
    const result = await listAll(listRef);
    const urlPromises = result.items.map((itemRef) => getDownloadURL(itemRef));
    const downloadURLs = await Promise.all(urlPromises);
    return downloadURLs;
  };
  /*-------------*/
const brandModelData = {
  Toyota: ["Innova Crysta [AC]", "Etios [AC]", "Glanza [AC]", "Innova Crysta [NON-AC]", "Etios [NON-AC]", "Glanza [NON-AC]"],
  Honda: ["City [AC]", "Amaze [AC]", "City [NON-AC]", "Amaze [NON-AC]"],
  Tata: ["Tigor [AC]", "Zest [AC]", "Indigo [AC]", "Tata wingor [AC]","Punch [AC]", "Tata sumo [AC]", "Tigor [NON-AC]", "Zest [NON-AC]", "Indigo [NON-AC]", "Tata wingor [NON-AC]", "Tata sumo [NON-AC]", "Punch [NON-AC]",],
  Hyundai: ["Xcent [AC]", "Aura [AC]", "Xcent [NON-AC]", "Aura [NON-AC]"],
  "Maruti Suzuki": ["Wagonr [AC]", "Dzire [AC]", "Ertiga [AC]", "Baleno [AC]", "Swift [AC]", "Wagonr [NON-AC]", "Dzire [NON-AC]", "Ertiga [NON-AC]", "Baleno [NON-AC]", "Swift [NON-AC]"],
  Mahindra: [ "Xylo [AC]", "Marazzo [AC]", "Bolero [AC]", "Scorpio [AC]", "Bolero neo [AC]", "Mahindra Max [AC]", "Xylo [NON-AC]", "Marazzo [NON-AC]", "Bolero [NON-AC]", "Scorpio [NON-AC]", "Bolero neo [NON-AC]", "Mahindra Max [NON-AC]"],
};

const [selectedBrand, setSelectedBrand] = useState("");
const [filteredModels, setFilteredModels] = useState([]);

  const [initialSelectedRoute, setInitialSelectedRoute] = useState([]);
const [initialSelectedSchedules, setInitialSelectedSchedules] = useState({});
const [initialRoutePrices, setInitialRoutePrices] = useState({});

// Reusable function to fetch and normalize vehicle route selection, schedules and prices
const fetchVehicleData = async (vehicleId) => {
  try {
    const response = await axios.get(`${keyUri.BACKEND_URI}/api/get-vehicle/${vehicleId}`);
    const vehicleData = response.data;

    const routes = vehicleData.route_id?.map((r) =>
      typeof r === "string" ? r : r._id
    ) || [];

    const schedules = {};
    const prices = {};

    (vehicleData.selected_schedules || []).forEach((item) => {
      const routeId = typeof item.route === "string" ? item.route : item.route._id;
      const schedArray = Array.isArray(item.schedules)
        ? item.schedules.map((sch) =>
            typeof sch === "string" ? sch : sch._id || sch
          )
        : [];

      const priceRaw = item.price_per_Trip;
      const priceVal =
        priceRaw && typeof priceRaw === "object" && "$numberDecimal" in priceRaw
          ? Number(priceRaw.$numberDecimal)
          : Number(priceRaw) || 0;

      schedules[routeId] = schedArray;
      prices[routeId] = { price_per_Trip: priceVal };
    });

    setInitialSelectedRoute(routes);
    setInitialSelectedSchedules(schedules);
    setInitialRoutePrices(prices);
  } catch (error) {
    console.error("Error fetching vehicle data for prefill", error);
    setInitialSelectedRoute([]);
    setInitialSelectedSchedules({});
    setInitialRoutePrices({});
  }
};
useEffect(() => {
  if (vehicle_for_route_change) {
    fetchVehicleData(vehicle_for_route_change);
  }
}, [vehicle_for_route_change]);

const handleBrandChange = (e) => {
  const brand = e.target.value;
  setSelectedBrand(brand);
  setFilteredModels(brandModelData[brand] || []);
  setNewVehicle({ ...newVehicle, brand_name: brand, model_name: "" }); // Reset model
};

const handleModelChange = (e) => {
  setNewVehicle({ ...newVehicle, model_name: e.target.value });
};


  /*-------------*/

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const imageLinks = await getAllImageLinksFromFolder("Loadout-Images/");
        setLoadoutImages(imageLinks);
      } catch (error) {
        console.error("Error fetching loadout images:", error);
      }
    };

    fetchImages();
  }, []);

  const handleDateChange = (vehicleId, type, value) => {
    if (type === "from") {
      setFromDate((prev) => ({ ...prev, [vehicleId]: value }));
    } else {
      setToDate((prev) => ({ ...prev, [vehicleId]: value }));
    }
  };

  /*const handleSaveUnavailability = async (vehicleId) => {
    const data = {
      vehicleId,
      from: fromDate[vehicleId],
      to: toDate[vehicleId],
    };

    // Log the data object
    console.log("Data being sent to API:", data);

    // Check if both 'from' and 'to' dates are provided
    if (!data.from || !data.to) {
      console.log("Validation Error: Missing 'from' or 'to' date.");
      alert("Please fill in both From and To dates.");
      return;
    }

    // Validate the format of 'from' and 'to' dates
    if (isNaN(new Date(data.from)) || isNaN(new Date(data.to))) {
      console.log("Validation Error: Invalid date format.");
      alert("Invalid date format.");
      return;
    }

    // Ensure the 'from' date is earlier than 'to' date
    if (new Date(data.from) >= new Date(data.to)) {
      console.log("Validation Error: 'From' date is later than 'To' date.");
      alert("From date should be earlier than To date.");
      return;
    }

    // Prepare the payload for the API request
    const payload = {
      from: new Date(data.from).toISOString(),
      to: new Date(data.to).toISOString(),
    };

    // Log the payload
    console.log("Payload being sent to API:", payload);

    try {
      // Make the API request to save unavailability
      console.log("Sending request to API...");
      const response = await axios.put(
        `${keyUri.BACKEND_URI}/api/vehicles/unavailability/${vehicleId}`,
        payload,
        config
      );

      // Log the API response
      console.log("API response:", response);

      // Show success toast
      toast.success(response.data.message, {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Clear the date fields
      setFromDate((prev) => {
        console.log("Clearing 'From' date for vehicleId:", vehicleId);
        return { ...prev, [vehicleId]: "" };
      });
      setToDate((prev) => {
        console.log("Clearing 'To' date for vehicleId:", vehicleId);
        return { ...prev, [vehicleId]: "" };
      });

      // Toggle the unavailability form visibility
      toggleUnavailabilityForm(vehicleId);
    } catch (error) {
      // Log the error details
      console.error("Error saving unavailability:", error);

      // Handle error and display the error message
      if (error.response && error.response.data) {
        console.log("API error response:", error.response.data);
        alert(
          `Error: ${error.response.data.message || "Something went wrong!"}`
        );
      } else {
        console.log("Network or unexpected error occurred:", error);
        alert("Something went wrong! Please try again.");
      }
    }
  };*/

  
const [toggleUnavailable, setToggleUnavailable] = useState({}); // vehicleId -> bool

const handleToggleUnavailability = async (vehicleId) => {
  const newStatus = !toggleUnavailable[vehicleId];
  try {
    const res = await axios.put(
      `${keyUri.BACKEND_URI}/api/vehicles/toggle-unavailability/${vehicleId}`,
      { makeUnavailable: newStatus },
      config
    );
    toast.success(res.data.message);
    setToggleUnavailable(prev => ({ ...prev, [vehicleId]: newStatus }));
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to toggle availability");
  }
};

  /* -------------------------------------------*/
const fetchUnavailability = async (vehicleId) => {
  try {
    const res = await axios.get(
      `${keyUri.BACKEND_URI}/api/get-vehicles/unavailability/${vehicleId}`,
      config
    );
    if (res.data.from && res.data.to) {
      setFromDate(prev => ({ ...prev, [vehicleId]: res.data.from.slice(0, 10) }));
      setToDate(prev => ({ ...prev, [vehicleId]: res.data.to.slice(0, 10) }));
    } else {
      setFromDate(prev => ({ ...prev, [vehicleId]: "" }));
      setToDate(prev => ({ ...prev, [vehicleId]: "" }));
    }
  } catch (err) {
    console.error("Error fetching unavailability", err);
  }
};

const toggleUnavailabilityForm = (vehicleId) => {
  setUnavailabilityForms(prev => {
    const newState = { ...prev, [vehicleId]: !prev[vehicleId] };
    if (!prev[vehicleId]) {
      fetchUnavailability(vehicleId); // fetch only when opening
    }
    return newState;
  });
};

const handleSaveUnavailability = async (vehicleId) => {
  if (!fromDate[vehicleId] || !toDate[vehicleId]) {
    alert("Please fill in both From and To dates.");
    return;
  }

  if (new Date(fromDate[vehicleId]) >= new Date(toDate[vehicleId])) {
    alert("From date should be earlier than To date.");
    return;
  }

  try {
    const payload = {
      from: new Date(fromDate[vehicleId]).toISOString(),
      to: new Date(toDate[vehicleId]).toISOString(),
    };

    const res = await axios.put(
      `${keyUri.BACKEND_URI}/api/vehicles/unavailability/${vehicleId}`,
      payload,
      config
    );

    toast.success(res.data.message || "Unavailability saved");
    toggleUnavailabilityForm(vehicleId);
  } catch (err) {
    toast.error("Failed to save unavailability");
  }
};

const handleRemoveUnavailability = async (vehicleId) => {
  try {
    await axios.delete(
      `${keyUri.BACKEND_URI}/api/vehicles/remove-unavailability/${vehicleId}`,
      config
    );
    setFromDate(prev => ({ ...prev, [vehicleId]: "" }));
    setToDate(prev => ({ ...prev, [vehicleId]: "" }));
    toast.success("Unavailability removed");
  } catch (err) {
    toast.error("Failed to remove unavailability");
  }
};



  /*--------------------------------------------*/
 console.log("🔍 Raw Bookings:", getAllBooks);
 


  const filterUpcomingRides = (rides) => {
  const todayOnly = new Date().setHours(0, 0, 0, 0);
  const next7Days = new Date().setDate(new Date().getDate() + 7);

  return rides
  .filter(ride => ride.status !== "Ride Completed") 
    .map((ride) => {
      
      const rideDateOnly = new Date(ride.rideDate).setHours(0, 0, 0, 0);

      // Filter seats with captured payment
     const capturedSeats = ride.bookedSeats?.filter(
  (seat) => seat.rideId?.payment_status === "captured"
);


      // Only return ride if it's upcoming and has at least one captured seat
      if (
        rideDateOnly >= todayOnly &&
        rideDateOnly <= next7Days &&
        capturedSeats.length > 0
      ) {
        return {
          ...ride,
          bookedSeats: capturedSeats, // Include only captured seats
        };
      }

      return null;
    })
    .filter((ride) => ride !== null); // Remove nulls
};


  const upcomingRides = filterUpcomingRides(getAllBooks || []);
  console.log("🚀 Upcoming Rides With Only Captured Payment Seats:", upcomingRides);

  console.log("🚀 Upcoming Rides:", upcomingRides);

  console.log("getAllBooks is-------", upcomingRides);

  const driver_id_ =
    localStorage.getItem("driverid") || localStorage.getItem("Driver");
  const [newVehicle, setNewVehicle] = useState({
    reg_no: "",
    type: "",
    capacity: "",
    category: "",
    brand_name: "",
    model_name: "",
    driverId: driver_id_ || current_driver?._id,
    Verified: false,
    Verification_expires: "",
    Booking_status: false,
    seats: [],
    picture_of_the_vehicle: null,
    Regestration_document_link: null,
    Insurance_document_link: null,
    price_per_km: "",
    price_per_trip: "",
    loadout_image: "",
    cab_available_for: "",
  });

  const close_edit_modal = () => {
    seteditmodal(false);
  };
  const open_edit_modal = () => {
    seteditmodal(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCustomerDetails(null);
  };

const filteredLoadouts = loadoutImagess.filter(
  (img) => img.capacity === Number(newVehicle.capacity)
);



  // const handleFileChange = async (e) => {
  //   const { name, files } = e.target;
  //   if (files.length === 0) return;

  //   const file = files[0];
  //   const storageRef = ref(storage, `vehicleDocuments/${file.name}`);
  //   setIsUploading(true);

  //   const uploadTask = uploadBytesResumable(storageRef, file);

  //   uploadTask.on(
  //     "state_changed",
  //     (snapshot) => {
  //       const progress =
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //       setUploadProgress(progress);
  //     },
  //     (error) => {
  //       toast.error("File upload failed: " + error.message);
  //       setIsUploading(false);
  //     },
  //     async () => {
  //       const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
  //       setNewVehicle((prev) => ({
  //         ...prev,
  //         [name]: downloadURL,
  //       }));
  //       toast.success("File uploaded successfully!");
  //       setIsUploading(false);
  //     }
  //   );
  // };
  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    if (files.length === 0) return;

    const file = files[0];

    // 👇 Only check image type for the 'picture_of_the_vehicle' field
    if (
      name === "picture_of_the_vehicle" &&
      ![
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
        "image/webp",
      ].includes(file.type)
    ) {
      toast.error(
        "Only image files (jpg, png, gif, webp) are allowed for vehicle image."
      );
      e.target.value = null;
      return;
    }

    const storageRef = ref(storage, `vehicleDocuments/${file.name}`);
    setIsUploading(true);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        toast.error("File upload failed: " + error.message);
        setIsUploading(false);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setNewVehicle((prev) => ({
          ...prev,
          [name]: downloadURL,
        }));
        toast.success("File uploaded successfully!");
        setIsUploading(false);
      }
    );
  };

  useEffect(() => {
    const driverid = localStorage.getItem("Driver");
    // const driver_id_ = localStorage.getItem("driverid")
    console.log("Setting otp's respective login setup", driverid);

    dispatch(fetchAllroute());
    if (driverid) {
      dispatch(fetchAllbooking(driverid));
    }
    dispatch(fetchOnedriver(driver_id_));
    dispatch(fetchAllbooking(driver_id_));
    dispatch(getAllBookings(driver_id_));
  }, [dispatch, driver_id_]);

  useEffect(() => {
    if (driver?._id) {
      dispatch(fetchAllbooking(driver?.id));
    }
  }, [driver]);

  const handleInstallClick = () => {
    setInstallable(false);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        deferredPrompt = null;
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setInstallable(true);
    };

    const handleAppInstalled = () => {};

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      clearTimeout(timer);
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);
  console.log("all routes are here", all_route);
  const handleCloseClick = () => {
    setInstallable(false);
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       console.log("usr roi user hoai", user?._json?.email);
  //       const user_email = user?._json?.email;

  //       if (user_email) {
  //         const response = await axios.post(
  //           `${keyUri.BACKEND_URI}/api/getguyfrommail`,
  //           { email: user_email }
  //         );
  //         console.log("API response 🎈🎈🎈🎈🎈🎈", response?.data);
  //         localStorage.setItem("driver", response?.data?.driver._id);
  //         setUserData(response?.data?.driver);
  //         localStorage.setItem("authToken", response?.data?.token);
  //       } else {
  //         console.error("Email is not available.");
  //       }
  //     } catch (err) {
  //       console.error("Error occurred while creating driver:", err);
  //     }
  //   };

  //   if (user?._json?.email) {
  //     fetchData();
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (!userData) {
  //     setUserData(driver);
  //   }
  // }, driver);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       console.log("usr roi user hoai", user?._json?.email);
  //       const user_phone = localStorage.getItem("phoneNumber")
  //         ? localStorage.getItem("phoneNumber")
  //         : null;
  //       console.log("user phone number", user_phone);

  //       if (user_phone) {
  //         const response = await axios.post(
  //           `${keyUri.BACKEND_URI}/api/getdriverfromphone`,
  //           { phone: user_phone }
  //         );
  //         console.log("API response 🎈🎃🎠", response?.data);
  //         localStorage.setItem("Driver", response?.data?.driver?._id);
  //         setUserData(response?.data?.driver);
  //         localStorage.setItem("authToken", response?.data?.token);
  //       } else {
  //         console.error("phone number is not available.");
  //       }
  //     } catch (err) {
  //       console.error("Error occurred while creating driver:", err);
  //     }
  //   };

  //   if (localStorage.getItem("phoneNumber")) {
  //     fetchData();
  //   }
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => setCurrentDate(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  console.log("Authentication got it ", authStatus);
  const cookies = document.cookie;
  console.log(cookies);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

   const updateVehicleData = async (data) => {
  // send POST/PUT request including price_per_Trip for each route
  await axios.put(`${keyUri.BACKEND_URI}/api/update-vehicle/${vehicle_for_route_change}`, data);
};
 // Update your handleSaveRoutes to refetch after save:
const handleSaveRoutes = async (data) => {
  try {
    // Optimistic update
    setInitialSelectedRoute(data.route_id || []);
    const newSchedules = {};
    const newPrices = {};

    (data.selected_schedules || []).forEach(item => {
      newSchedules[item.route] = item.schedules || [];
      newPrices[item.route] = { price_per_Trip: item.price_per_Trip || 0 };
    });

    setInitialSelectedSchedules(newSchedules);
    setInitialRoutePrices(newPrices);

    // Await backend update (optional: for error handling)
    await updateVehicleData(data);
    await fetchVehicleData(vehicle_for_route_change);

    toast.success("Vehicle updated successfully");
    setOpen(false);
  } catch (error) {
    toast.error("Failed to update vehicle");
  }
};

  const isRideSoon = (rideDate) => {
    const rideDateTime = new Date(rideDate);
    const currentUtcDate = new Date(Date.now());
    console.log("Ride Date", rideDateTime);
    console.log("Today Date", currentUtcDate);

    const timeDiffInMillis = rideDateTime.getTime() - currentUtcDate.getTime();

    const hoursDiff = timeDiffInMillis / (1000 * 60 * 60);
    console.log(`Time Diff (in hours): ${hoursDiff}`);

    return hoursDiff <= 24;
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (current_vehicle) {
      setNewVehicle({
        reg_no: current_vehicle?.reg_no,
        price_per_km: current_vehicle?.price_per_km?.$numberDecimal,
        price_per_trip: current_vehicle?.price_per_trip?.$numberDecimal,
        cab_available_for: current_vehicle?.cab_available_for || "Full-Cab",
        Regestration_document_link: current_vehicle?.Regestration_document_link,
        Insurance_document_link: current_vehicle?.Insurance_document_link,
      });
    }
  }, [current_vehicle]);

  const date_in_normal_form = (rideDate) => {
    // Convert the rideDate string to a Date object
    const rideDateObj = new Date(rideDate);

    // Options to format the date
    const options = {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };

    // Format the date to the desired format "Sunday, dd-mm-yyyy"
    const formattedDate = rideDateObj
      .toLocaleDateString("en-GB", options)
      .replace(",", "");

    return formattedDate;
  };
  const getFormattedTime = (rideDate) => {
    const rideDateObj = new Date(rideDate);

    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Ensures AM/PM format
    };

    return rideDateObj.toLocaleTimeString("en-GB", timeOptions);
  };

  console.log(driver?._id);
  console.log("here is the fkin driver", current_driver);
  console.log("here is user data", userData);

  const handleStatusChange = () => {
    const updatedStatus =
      rideStatus === "Not Started"
        ? "Ride Started"
        : rideStatus === "Ride Started"
        ? "Ride Completed"
        : rideStatus === "Ride Completed"
        ? "Ride Completed"
        : rideStatus;
    setRideStatus(updatedStatus);
    dispatch(updateSeatBooks(customerDetails?._id, { status: updatedStatus }));
    if (updatedStatus === "Ride Completed") {
      setReviewModalOpen(true);
    }
  };
  const [previouslyAssignedVehicleId, setPreviouslyAssignedVehicleId] = useState(null);
const [currentRouteId, setCurrentRouteId] = useState(null);
const [pricePerTrip, setPricePerTrip] = useState(0);
const [selectedSchedules, setSelectedSchedules] = useState([]);

const handleAddVehicle = async () => {
  console.log("New Vehicle Data:", newVehicle);
try{
  if (current_vehicle !== null) {
    const payload = {
        ...newVehicle,
        newVehicleId: current_vehicle._id,
        // Include these if relevant for route reassignment; otherwise omit or null
        oldVehicleId: previouslyAssignedVehicleId || null,
        routeIdToAssign: currentRouteId || null,
        pricePerTrip: pricePerTrip || 0,
        multiRoute: false, // or true if multi-route assignment
        selected_schedules: selectedSchedules || [],
      };
    await dispatch(updatevehicle(payload, current_vehicle?._id));
   // toast.success("Vehicle updated successfully.");
      setNewVehicle({ reg_no: "", price_per_km: "", price_per_trip: "" });
      setOpenEditVehicle(false);
  
  } else {
    const vehicleToCreate = {
      ...newVehicle,
      loadout_image: selectedImage,
    };

    await dispatch(createvehicle(vehicleToCreate));
    setOpenAddVehicle(false);
    //toast.success("Vehicle added successfully. Please refresh the page to see it.", {
 // position: "top-center",
//});

    setNewVehicle({
      reg_no: "",
      price_per_km: "",
      price_per_trip: "",
      // setOpenAddVehicle(false);
    });
     setOpenAddVehicle(false);
  }
  }catch (err) {
    console.error("Error while adding/updating vehicle:", err);
    toast.error(err?.message || "Failed to save vehicle. Please try again.");
  }
};


  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  const handle_edit = (id) => {
    setOpenEditVehicle(true);
    dispatch(fetchonevehicle(id));
  };

  const isRideStartingSoon = (rideDate) => {
    const now = new Date();
    const rideTime = new Date(rideDate);
    const diffInMinutes = (rideTime - now) / (1000 * 60); // Convert milliseconds to minutes

    return diffInMinutes <= 15;
  };
  const groupedBookings = customerDetails?.bookedSeats?.reduce(
    (acc, booking) => {
      const userId = booking?.userId?._id;

      if (!userId) return acc;

      if (!acc[userId]) {
        acc[userId] = {
          ...booking,
          seatNumbers: [...(booking?.seatNumbers || [])],
        };
      } else {
        acc[userId].seatNumbers.push(...(booking?.seatNumbers || []));
      }

      return acc;
    },
    {}
  );
  return (
    <div>
      {console.log("loadout images will be here boi", loadoutImages)}
      {console.log(all_booking)}
      {console.log("all booking details", all_booking)}
      {authStatus || driverAuthenticate ? (
        <div>
          <div className="relative bg-gray-900 text-white text-center py-16 mt-32">
            <h2 className="text-4xl font-bold mb-2">Welcome</h2>
            <h2 className="text-4xl font-bold mb-2">
              {userData?.name || current_driver?.name}
            </h2>
            <h3 className="text-2xl font-bold mb-6 ">{`${date}, ${weekday}`}</h3>
            <p className="text-lg font-light mb-6">
              Track all your Rides and keep transactions organized
            </p>
            <form className="flex flex-wrap justify-center w-full gap-4 mt-6">
              <button
                type="button"
                onClick={() => {
                  navigate("/pastcollabs");
                }}
                className="px-6 py-3 text-sm font-medium tracking-wide text-white bg-purple-500 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
              >
                View Past Rides
              </button>
              <button
                type="button"
                onClick={() => {
                  navigate("/futurecollabs");
                }}
                className="px-9 py-3 text-sm font-medium tracking-wide text-white bg-purple-500 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
              >
                Future Rides
              </button>
              {!current_driver?.underAgency && (
              <button
                onClick={() => {
                  navigate("/createassignment");
                }}
                type="button"
                className="px-8 py-3 text-sm font-medium tracking-wide text-white bg-purple-500 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
              >
                Set Unavailability
              </button>
              )}
            </form>
          </div>
          <div className="mt-6 mb-12">
            <h1 className="font-bold text-4xl text-center">Upcoming Rides</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-4 sm:px-6 md:px-8 py-6 w-full max-w-screen-xl mx-auto">
              {upcomingRides && upcomingRides.length > 0 ? (
                [...upcomingRides]
                  .sort((a, b) => new Date(a.rideDate) - new Date(b.rideDate))
                  .map((product) => (
                    <div
                      key={product?._id}
                      className="max-w-sm bg-white dark:bg-gray-800 shadow-md rounded-lg p-4"
                    >
                      <h5 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {product?.route?.name}
                      </h5>
                      <h5 className="text-l font-bold tracking-tight text-gray-900 dark:text-white">
                        {product?.vehicleId?.brand_name} {product?.vehicleId?.model_name}
                      </h5>
                      {/* <p>{product?._id}</p> */}
                      <span className="dark:text-white">
                        {date_in_normal_form(product?.rideDate)}
                      </span>
                      <br></br>
                      <span className="dark:text-white">
                        {getFormattedTime(product?.rideDate)}
                      </span>
                      <p className="text-sm text-gray-500">
                        {isRideSoon(product?.rideDate) ? (
                          <div>
                            <button
                              className="flex items-center mt-4 px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
                              onClick={() => handleseecustomer(product)}
                            >
                              See Customer Details
                            </button>

                            {isModalOpen &&
                              customerDetails?._id === product?._id && (
                                <div
                                  className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50 z-50 mt-48"
                                  onClick={closeModal}
                                >
                                  <div
                                    className="bg-white rounded-lg w-96 p-6"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <h3 className="text-2xl font-semibold mb-4">
                                      Customer Details
                                    </h3>
                                    {console.log(
                                      "istam vochina data",
                                      customerDetails
                                    )}
                                    {Object.keys(groupedBookings).length > 0 ? (
                                      <div className="space-y-4">
                                        {Object.values(groupedBookings).map(
                                          (booking) => (
                                            <div
                                              key={booking?._id}
                                              className="border p-4 rounded-lg shadow"
                                            >
                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Name:
                                                </strong>
                                                <span className="text-gray-900">
                                                  {booking?.userId?.name ||
                                                    "N/A"}
                                                </span>
                                              </div>

                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Email:
                                                </strong>
                                                <span className="text-gray-900">
                                                  {booking?.userId?.email ||
                                                    "Not Available"}
                                                </span>
                                                <span className="text-gray-900">
                                                  {console.log(
                                                    "inside loop of the loop",
                                                    booking
                                                  )}
                                                </span>
                                              </div>

                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Phone:
                                                </strong>
                                                <span className="text-gray-900">
                                                  {booking?.userId
                                                    ?.phone_number ||
                                                    "No Phone Number"}
                                                </span>
                                              </div>

                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Pickup Point:
                                                </strong>
                                                <span className="text-gray-900">
                                                  {booking?.rideId
                                                    ?.pickup_point || "N/A"}
                                                </span>
                                              </div>

                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Drop Point:
                                                </strong>
                                                <span className="text-gray-900">
                                                  {booking?.rideId
                                                    ?.drop_point || "N/A"}
                                                </span>
                                              </div>

                                              <div className="flex items-start space-x-1">
                                                <strong className="text-gray-700">
                                                  Seat Numbers:
                                                </strong>
                                                <ul className="list-disc pl-5 text-gray-800 space-y-1">
                                                  {booking?.seatNumbers.map(
                                                    (seat, idx) => (
                                                      <li
                                                        key={idx}
                                                        className="text-gray-900"
                                                      >
                                                        {seat}
                                                      </li>
                                                    )
                                                  )}
                                                </ul>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      <p>No customer data available.</p>
                                    )}

                                    <div className="flex justify-between mb-16">
                                      <button
                                        className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
                                        onClick={closeModal}
                                      >
                                        Close
                                      </button>
                                      {isRideStartingSoon(
                                        product?.rideDate
                                      ) && (
                                        <button
                                          className="mt-4 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700"
                                          onClick={handleStatusChange}
                                          disabled={
                                            rideStatus === "Ride Completed"
                                          }
                                        >
                                          {rideStatus === "Not Started"
                                            ? "Start Ride"
                                            : rideStatus === "Ride Started"
                                            ? "Mark As Ride Complete"
                                            : "Ride Completed"}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        ) : (
                          <div>
                            <p className="text-sm font-semibold text-red-500 mt-3">
                              You can only view customer details before 24 hours
                              of ride time.
                            </p>
                          </div>
                        )}
                      </p>
                    </div>
                  ))
              ) : (
                <p className="text-center text-gray-500">
                  No upcoming rides available.
                </p>
              )}
            </div>
          </div>
          {/*  review */}
          {reviewModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-md w-96">
                <h2 className="text-xl font-bold mb-4 text-gray-800">
                  {review && review.length > 0
                    ? "Your Review"
                    : "Leave a Review"}
                </h2>

                {review && review.length > 0 ? (
                  <div>
                    <div className="flex space-x-1 mb-4">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`text-2xl ${
                            star <= review[0]?.stars
                              ? "text-yellow-400"
                              : "text-gray-300"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    {review[0]?.comment && (
                      <p className="text-gray-700 border border-gray-300 p-3 rounded-lg">
                        {review[0]?.comment}
                      </p>
                    )}
                  </div>
                ) : (
                  <div>
                    <div className="flex space-x-1 mb-4">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          onClick={() => setReviewStars(star)}
                          className={`text-2xl ${
                            star <= reviewStars
                              ? "text-yellow-400"
                              : "text-gray-300"
                          }`}
                        >
                          ★
                        </button>
                      ))}
                    </div>

                    <textarea
                      value={reviewComment}
                      onChange={(e) => setReviewComment(e.target.value)}
                      placeholder="Write your review here..."
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    ></textarea>

                    <button
                      onClick={async () => {
                        try {
                          await axios.post(
                            `${keyUri.BACKEND_URI}/api/createdriverReview`,
                            {
                              rideId: customerDetails?._id,
                              stars: reviewStars,
                              comment: reviewComment,
                            }, config
                          );
                          toast.success("Thank you for your review!");
                        } catch (err) {
                          toast.error("Failed to submit review.");
                        } finally {
                          setReviewModalOpen(false);
                        }
                      }}
                      className="w-full bg-blue-600 text-white py-2 mt-4 rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                      Submit Review
                    </button>
                  </div>
                )}

                <button
                  className="mt-3 w-full bg-red-600 text-white p-2 rounded-md hover:bg-red-700"
                  onClick={() => setReviewModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          )}
          <div className="flex flex-col items-center justify-center space-y-6 mb-14">
            <div className="flex flex-col md:flex-row justify-between w-full px-4">
              {/* <h1 className="text-3xl font-bold text-black dark:text-white md:ml-[40%] mb-4 md:mb-0">
                Your Vehicles
              </h1> */}
              <h1 className="text-3xl font-bold md:ml-[40%] mb-4 md:mb-0">
                {" "}
                Your Vehicles
              </h1>
              <div className="md:mr-[40%]">
             {!current_driver?.underAgency && (
  <Button
    variant="contained"
    color="primary"
    sx={{
      marginRight: "16px",
      backgroundColor: "#2563eb",
      "&:hover": {
        backgroundColor: "#1d4ed8",
      },
    }}
    onClick={handleOpenAddVehicle}
  >
    Add Vehicle
  </Button>
)}

              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-6 px-4">
              {userData ||
                current_driver?.vehicleId?.map((vehicle, index) => (
                  <div
                    key={index}
                    className="flex bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 p-4 rounded-lg shadow-md w-full sm:w-[26rem] lg:w-96 transition-colors duration-200"
                  >
                    <div className="w-32 h-32 flex-shrink-0">
                      <img
                        src={vehicle?.picture_of_the_vehicle}
                        alt={vehicle?.name}
                        className="w-full h-full object-cover rounded-lg"
                      />
                    </div>

                    <div className="flex flex-col justify-between flex-1 ml-4">
                      <div>
                        <div className="flex items-center justify-between">
                          <h2 className="text-lg font-semibold mb-1 dark:text-white">
                            {`${vehicle?.reg_no}`}
                          </h2>
                          {!current_driver?.underAgency && (<Pencil
                            className="h-4 cursor-pointer text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400"
                            onClick={() => {
                              handle_edit(vehicle?._id);
                            }}
                          /> )}
                        </div>
                        <h3 className="text-lg font-semibold mb-1 dark:text-gray-200">
                          {`(${vehicle?.brand_name})`} {`(${vehicle?.model_name})`}
                        </h3>
                        <p><strong>Vehicle Category:</strong> {`${vehicle?.category}`}</p>
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Selected Routes:{" "}
                          <span className="font-medium dark:text-gray-100">
                            {(userData?.length > 0
                              ? userData
                              : current_driver?.vehicleId[index]?.route_id
                            )
                              ?.map((route) => route?.name)
                              .filter(Boolean)
                              .join(", ") || "No routes selected"}
                          </span>
                        </p>
                      </div>
                 {!current_driver?.underAgency && (
  <div className="flex justify-start mt-2 gap-10">
    {/* Set Route button */}
   <button
  className="bg-blue-600 dark:bg-blue-700 text-white py-1 px-3 w-38 rounded-md hover:bg-blue-500 dark:hover:bg-blue-600 transition-colors duration-200"
  onClick={() => {
    handleOpen();
    handlesetvehicleforroutechange(vehicle?._id);
  }}
>
  Select Route and Set Price
</button>


    {/* Toggle Switch above icon */}
    <div className="flex flex-col items-center">
     <FormControlLabel
        control={
          <Switch
            checked={!!toggleUnavailable[vehicle._id]}
            onChange={() => handleToggleUnavailability(vehicle._id)}
            color="primary"
          />
        }
        label={toggleUnavailable[vehicle._id] ? "Unavailable" : "Available"}
        labelPlacement="bottom"
      /> 

      {/* Car Unavailability Icon */}
      <button
        className="bg-white-100 hover:bg-white-200 p-2 rounded-full text-red-600 hover:text-red-800 transition"
        title="Set Unavailability"
        onClick={() => toggleUnavailabilityForm(vehicle?._id)}
      >
        <CarUnavailableIcon />
      </button>
    </div>
  </div>
)}

                      {unavailabilityForms[vehicle?._id] && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50">
                          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-auto relative">
                            {/* Close Button */}
                            <button
                              onClick={() =>
                                toggleUnavailabilityForm(vehicle._id)
                              }
                              className="absolute top-3 right-4 text-gray-900  hover:text-red-500"
                            >
                              &times;
                            </button>

                            {/* Modal Title */}
                            <h2 className="text-xl font-semibold text-gray-800  mb-4">
                              Set Unavailability
                            </h2>

                            {/* From Date */}
                            <div className="mb-4">
                              <label className="block text-sm font-medium text-gray-900 mb-1">
                                From
                              </label>
                              <input
                                type="date"
                                className="w-full border border-gray-300 rounded px-3 py-2 dark:bg-white-500 dark:text-black"
                                value={fromDate[vehicle._id] || ""}
                                onChange={(e) =>
                                  handleDateChange(
                                    vehicle._id,
                                    "from",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            {/* To Date */}
                            <div className="mb-4">
                              <label className="block text-sm font-medium text-gray-900 mb-1">
                                To
                              </label>
                              <input
                                type="date"
                                className="w-full border border-gray-300 rounded px-3 py-2 dark:bg-white-500 dark:text-black"
                                value={toDate[vehicle._id] || ""}
                                onChange={(e) =>
                                  handleDateChange(
                                    vehicle._id,
                                    "to",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            {/* Save Button */}
                            <div className="flex justify-end gap-4 mt-6">
                              <button
                                onClick={() =>
                                  toggleUnavailabilityForm(vehicle._id)
                                }
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                              >
                                Cancel
                              </button>

                                {fromDate[vehicle._id] && toDate[vehicle._id] && (
    <button
      onClick={() => handleRemoveUnavailability(vehicle._id)}
      className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-500"
    >
      Remove Unavailability
    </button>
  )}

                              <button
                                onClick={() =>
                                  handleSaveUnavailability(vehicle._id)
                                }
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-500"
                              >
                                Save Unavailability
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <RouteSelectionModal
                      open={open}
                      handleClose={handleClose}
                      routes={all_route}
                      onSave={handleSaveRoutes}
                      vehicleid={vehicle_for_route_change}
                      driver={userData?._id}
                      // initialSelectedRoute={}
                       initialSelectedRoute={initialSelectedRoute}
  initialSelectedSchedules={initialSelectedSchedules}
  initialRoutePrices={initialRoutePrices}
                      className="dark:bg-gray-800 dark:text-white"
                    />
                  </div>
                ))}
            </div>
          </div>
          {openAddVehicle && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto p-4 z-50 ">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto mt-64">
                <h2 className="text-xl font-bold mb-4 text-gray-900">
                  Add New Vehicle
                </h2>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Registration No. *
                  </label>
                  <input
                    type="text"
                    name="reg_no"
                    value={newVehicle.reg_no}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Vehicle Type *
                  </label>
                  <select
                    name="type"
                    value={newVehicle.type}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  >
                    <option value="">Select Type</option>
                    {vehicleTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Vehicle Capacity(Passengers + Driver) *
                  </label>

                  <select
                    name="capacity"
                    value={newVehicle.capacity}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  >
                    <option value="">Select capacity</option>
                    {seatOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Vehicle Category *
                  </label>
                  <select
                    name="category"
                    value={newVehicle.category}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  >
                    <option value="">Select Category</option>
                    {categoryTypes.map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>
{/* Brand Dropdown */}
<div className="mb-3">
  <label className="block text-sm font-medium text-gray-700">
    Brand Name *
  </label>
  <select
    name="brand_name"
    value={newVehicle.brand_name}
    onChange={handleBrandChange}
    required
    className="mt-1 p-2 w-full border rounded-md"
  >
    <option value="">Select Brand</option>
    {Object.keys(brandModelData).map((brand) => (
      <option key={brand} value={brand}>
        {brand}
      </option>
    ))}
  </select>
</div>

{/* Model Dropdown */}
<div className="mb-3">
  <label className="block text-sm font-medium text-gray-700">
    Model Name *
  </label>
  <select
    name="model_name"
    value={newVehicle.model_name}
    onChange={handleModelChange}
    required
    className="mt-1 p-2 w-full border rounded-md"
    disabled={!selectedBrand}
  >
    <option value="">Select Model</option>
    {filteredModels.map((model) => (
      <option key={model} value={model}>
        {model}
      </option>
    ))}
  </select>
</div>


                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Verification Expires *
                  </label>
                  <input
                    type="date"
                    name="Verification_expires"
                    value={newVehicle.Verification_expires}
                    onChange={handleChange}
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Price Per Km for Reserve Cabs(Driver Fixed) *
                  </label>
                  <input
                    type="text"
                    name="price_per_km"
                    value={newVehicle.price_per_km}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

             { /*  <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Price Per Trip
                  </label>
                  <input
                    type="text"
                    name="price_per_trip"
                    value={newVehicle.price_per_trip}
                    onChange={handleChange}
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>*/}

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Set Vehicle for *
                  </label>
                  <select
                    name="cab_available_for"
                    value={newVehicle.cab_available_for}
                    onChange={handleChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  >
                    <option value="">Select Type</option>
                    {cabfor.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Registration Document
                  </label>
                  <input
                    type="file"
                    name="Regestration_document_link"
                    onChange={handleFileChange}
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Insurance Document
                  </label>
                  <input
                    type="file"
                    name="Insurance_document_link"
                    onChange={handleFileChange}
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Vehicle Image *
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="picture_of_the_vehicle"
                    onChange={handleFileChange}
                    required
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                   <p className="mt-1 text-xs text-gray-500">
   This is the image visible to users during booking.
  </p>
                </div>
                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Your Vehicle Seating Arrangement
                  </label>
                  {filteredLoadouts.map((img, index) => (
                    <Box
                      key={index}
                      onClick={() => handleImageClick(img.url)}
                      sx={{
                        width: 250,
                        height: 400,
                        backgroundColor: "#f9f9f9",
                        border:
                          selectedImage === img.url ? "3px solid" : "1px solid",
                        borderColor:
                          selectedImage === img.url ? "primary.main" : "grey.300",
                        borderRadius: 2,
                        cursor: "pointer",
                        overflow: "hidden",
                        boxShadow: selectedImage === img.url ? 6 : 1,
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "&:hover": {
                          boxShadow: 4,
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      <img
                        src={img.url}
                        alt={`Loadout option ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          objectPosition: "center",
                          padding: "8px",
                        }}
                      />
                    </Box>
                  ))}
                </div>

                <button
                  onClick={() => handleAddVehicle(newVehicle)}
                  className="mt-3 w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700"
                >
                  Submit
                </button>
                <button
                  onClick={() => handleCloseAddVehicle()}
                  className="mt-3 w-full bg-red-600 text-white p-2 rounded-md hover:bg-red-700"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
          ;
          {editmodal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 pt-[34rem] mt-[4rem] overflow-y-scroll pb-14">
              <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4 text-gray-900">
                  Add New Vehicle
                </h2>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Registration No.
                  </label>
                  <input
                    type="text"
                    name="reg_no"
                    value={newVehicle.reg_no}
                    onChange={handleChange}
                    className="mt-1 p-2 w-full border rounded-md"
                  />
                </div>

                <button
                  onClick={() => handleAddVehicle(newVehicle)}
                  className="mt-3 w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700"
                >
                  Submit
                </button>
                <button
                  onClick={() => handleCloseAddVehicle()}
                  className="mt-3 w-full bg-red-600 text-white p-2 rounded-md hover:bg-red-700"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <h1>Please login to continue</h1>
        </div>
      )}
      <div>
        <Install
          installable={installable}
          onInstallClick={handleInstallClick}
          onCloseClick={handleCloseClick}
        />
      </div>

      {openEditVehicle && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50  overflow-y-scroll mb-20">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4 text-gray-900">
              Edit Vehicle
            </h2>

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700">
                Registration No.
              </label>
              <input
                type="text"
                name="reg_no"
                value={newVehicle.reg_no}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded-md"
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700">
                Price per KM for Reserve Cabs (Driver Fixed)
              </label>
              <input
                type="text"
                name="price_per_km"
                value={newVehicle.price_per_km}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded-md"
              />
            </div>
            
      {/* Cab Type */}
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700">
          Cab Available For
        </label>
        <select
          name="cab_available_for"
          value={newVehicle.cab_available_for || "Full-Cab"}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        >
          <option value="Full-Cab">Reserve Cab</option>
          <option value="Shared-cab">Shared Cab</option>
          <option value="Both">Both</option>
        </select>
        </div>
        
  {/* Registration Document */}
<div className="mb-3 mt-2">
  <label className="block text-sm font-medium text-gray-700">
    Registration Document
  </label>

  {/* Show existing document link if available */}
  {newVehicle.Regestration_document_link ? (
    <a
      href={newVehicle.Regestration_document_link}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline block mb-2"
    >
      View Existing Registration Document
    </a>
  ) : (
    <p className="text-gray-500">No document uploaded</p>
  )}

  {/* File input for uploading new document */}
  <input
    type="file"
    name="Regestration_document_link"
    accept="image/*,application/pdf,.doc,.docx"
    onChange={handleFileChange}
    className="mt-1 p-2 w-full border rounded-md"
  />
</div>


{/* Insurance Document */}
<div className="mb-3">
  <label className="block text-sm font-medium text-gray-700">
    Insurance Document
  </label>

  {/* Show existing document link if available */}
  {newVehicle.Insurance_document_link ? (
    <a
      href={newVehicle.Insurance_document_link}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline block mb-2"
    >
      View Existing Insurance Document
    </a>
  ) : (
    <p className="text-gray-500">No document uploaded</p>
  )}

  {/* File input for uploading new document */}
  <input
    type="file"
    name="Insurance_document_link"
    accept="image/*,application/pdf,.doc,.docx"
    onChange={handleFileChange}
    className="mt-1 p-2 w-full border rounded-md"
  />
</div>


           {/* <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700">
                Price Per Trip
              </label>
              <input
                type="text"
                name="price_per_trip"
                value={newVehicle.price_per_trip}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded-md"
              />
            </div>*/}

            <button
              onClick={() => handleAddVehicle(newVehicle)}
              className="mt-3 w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700"
            >
              Update
            </button>
            <button
              onClick={() => setOpenEditVehicle(false)}
              className="mt-3 w-full bg-red-600 text-white p-2 rounded-md hover:bg-red-700"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
